export default class MessageContentMediaType {
    static General = 0;
    static Image = 1;
    static Voice = 2;
    static Video = 3;
    static File = 4;
    static Portrait = 5;
    static Fvaorite = 6;
}


// WEBPACK FOOTER //
// ./src/fscommon/websocket/message/messageContentMediaType.js